import { render, staticRenderFns } from "./OmzetPrint_Details2.vue?vue&type=template&id=6ec6e6e7&"
import script from "./OmzetPrint_Details2.vue?vue&type=script&lang=js&"
export * from "./OmzetPrint_Details2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports